var SlideMenuItems = [
    {
        type: 'item',
        icon: 'dripicons-meter',
        name: 'Dashboard',
        router: {
            name: 'home'
        }
    },
    {
        type: 'item',
        icon: 'dripicons-gear',
        name: 'Setting',
        router: {
            name: 'setting'
        }
    },

    {
        type: 'item',
        icon: 'dripicons-store',
        name: 'Storefront',
        router: {
            name: 'store'
        }
    },
    {
        type: 'item',
        icon: 'fi fi-box',
        name: 'Campaigns',
        router: {
            name: 'campaign'
        }
    },
    /*    {
            type: 'item',
            icon: 'fi fi-tag',
            name: 'Promotions',
            router: {
                name: 'promotion'
            }
        },*/
    /* {
         type: 'item',
         icon: 'dripicons-graph-bar',
         name: 'Campaigns stats',
         router: {
             name: 'analytic'
         }
     },*/
    {
        type: 'item',
        icon: 'dripicons-cart',
        name: 'Orders',
        router: {
            name: 'order'
        }
    },
    /* {
         type: 'item',
         icon: 'fi fi-head',
         name: 'Customers',
         router: {
             name: 'customer'
         }
     },
     {
         type: 'item',
         icon: 'fi fi-mail',
         name: 'Emails',
         router: {
             name: 'email'
         }
     },*/
    {
        type: 'item',
        icon: 'dripicons-print',
        name: 'Fulfillment',
        router: {
            name: 'fulfillment'
        }
    },
    {
        type: 'item',
        icon: 'fi-share',
        name: 'Marketing',
        router: {
            name: 'marketing'
        },
        sub: [
            {
                type: 'item',
                icon: 'dripicons-print',
                name: 'Google Merchant',
                router: {
                    name: 'marketing'
                }
            },
            {
                type: 'item',
                icon: 'dripicons-print',
                name: 'Facebook Catalog',
                router: {
                    name: 'marketing_facebook'
                }
            },
            {
                type: 'item',
                icon: 'dripicons-print',
                name: 'Amazon Listing',
                router: {
                    name: 'marketing_amazon'
                }
            },
        ]
    },
    {
        type: 'item',
        icon: 'dripicons-wallet',
        name: 'Billing',
        router: {
            name: 'billing'
        }
    },

    {
        type: 'item',
        icon: 'dripicons-link',
        name: 'Intergrations',
        router: {
            name: 'integrate_woocommerce'
        },
        sub: [
            {
                type: 'item',
                name: 'WooCommerce',
                icon: '',
                router: {
                    name: 'integrate_woocommerce'
                }
            },
            {
                type: 'item',
                icon: '',
                name: 'Shopify',
                router: {
                    name: 'integrate_shopify'
                }
            },
            {
                type: 'item',
                icon: '',
                name: 'Etsy',
                router: {
                    name: 'integrate_etsy'
                }
            },
        ]
    },

]

export default SlideMenuItems
